"use strict";
// --------------------------------------------------------------------------------------------------------------------
// <copyright file="CalendarRoot.ts" company="Microsoft">
//   Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
// <summary>
//   TypeScript implementation of the HxCalendarRoot object
//   THIS FILE IS GENERATED BY A TOOL -- OBJECTGEN, DO NOT EDIT BY HAND
// </summary>
// --------------------------------------------------------------------------------------------------------------------
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HxCalendarRoot = void 0;
var HxObject_1 = __importDefault(require("./HxObject"));
var HxObjectID_1 = __importDefault(require("./HxObjectID"));
var HxObjectType_1 = __importDefault(require("./HxObjectType"));
var HxTimeRange_1 = require("./HxTimeRange");
var HxCalendarRoot = /** @class */ (function (_super) {
    __extends(HxCalendarRoot, _super);
    function HxCalendarRoot(objectId, storageSequenceNumber, obj, activeSet) {
        var _this = _super.call(this, objectId, HxObjectType_1.default.HxCalendarRoot, storageSequenceNumber, activeSet) || this;
        _this.update(obj);
        return _this;
    }
    HxCalendarRoot.getAppointmentHeaderTimeRange = function (item) {
        return item.timeRangeUtc;
    };
    HxCalendarRoot.prototype.update = function (obj) {
        var e_1, _a;
        try {
            for (var _b = __values(Object.entries(obj)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var _d = __read(_c.value, 2), key = _d[0], v = _d[1];
                switch (key) {
                    case '1':
                        this.objectId = new HxObjectID_1.default(v);
                        break;
                    case '2':
                        this.parentId = new HxObjectID_1.default(v);
                        break;
                    case '1CE':
                        this.appointmentCacheRange = HxTimeRange_1.deserializeHxTimeRange(v);
                        break;
                    case '1CF':
                        this.appointmentOnlineFetchRange = HxTimeRange_1.deserializeHxTimeRange(v);
                        break;
                    case 'A97':
                        this.appointmentsViewId = new HxObjectID_1.default(v);
                        break;
                    case 'DF3':
                        this.byAttendeeAppointmentsViewId = new HxObjectID_1.default(v);
                        break;
                    case '1CA':
                        this.calendarGroupsId = new HxObjectID_1.default(v);
                        break;
                    case '1C9':
                        this.calendarsId = new HxObjectID_1.default(v);
                        break;
                    case 'F2D':
                        this.calendarsIncludingGroupCalendarsId = new HxObjectID_1.default(v);
                        break;
                    case '13E0':
                        this.fetchCalendarStatusType = v;
                        break;
                    case '4A3':
                        this.holidayCatalogId = new HxObjectID_1.default(v);
                        break;
                    case '158C':
                        this.iconCatalogId = new HxObjectID_1.default(v);
                        break;
                    case '385':
                        this.lastFetchAppointmentDeviceId = v;
                        break;
                    case '386':
                        this.lastFetchAppointmentInstanceDate = new Date(v);
                        break;
                    case '62B':
                        this.locationSuggestionsDataCollectionsId = new HxObjectID_1.default(v);
                        break;
                    case '44F':
                        this.notificationDataCacheId = new HxObjectID_1.default(v);
                        break;
                    case '450':
                        this.notificationDataTimeRange = HxTimeRange_1.deserializeHxTimeRange(v);
                        break;
                    case '1CD':
                        this.photosId = new HxObjectID_1.default(v);
                        break;
                    case '994':
                        this.searchResultsId = new HxObjectID_1.default(v);
                        break;
                    case '854':
                        this.sharingPermissionInfoRequestsDataCollectionsId = new HxObjectID_1.default(v);
                        break;
                    case '855':
                        this.sharingPermissionsRequestsDataCollectionsId = new HxObjectID_1.default(v);
                        break;
                    case '1CB':
                        this.weatherId = new HxObjectID_1.default(v);
                        break;
                    case '314':
                        this.weatherUpdatesId = new HxObjectID_1.default(v);
                        break;
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
    };
    HxCalendarRoot.prototype.getAppointmentsView = function (start, end, sessionId) {
        return this.activeSet.getCollectionByTimeRange(this.appointmentsViewId, HxObjectType_1.default.HxAppointmentHeaderCollection, 517 /* HxAppointmentHeader_TimeRangeUtc */, start, end, HxCalendarRoot.getAppointmentHeaderTimeRange, sessionId);
    };
    HxCalendarRoot.prototype.getByAttendeeAppointmentsView = function (start, end, sessionId) {
        return this.activeSet.getCollectionByTimeRange(this.byAttendeeAppointmentsViewId, HxObjectType_1.default.HxAppointmentHeaderCollection, 517 /* HxAppointmentHeader_TimeRangeUtc */, start, end, HxCalendarRoot.getAppointmentHeaderTimeRange, sessionId);
    };
    HxCalendarRoot.prototype.getCalendarGroups = function (sessionId) {
        return this.activeSet.getCollection(this.calendarGroupsId, sessionId);
    };
    HxCalendarRoot.prototype.getCalendars = function (sessionId) {
        return this.activeSet.getCollection(this.calendarsId, sessionId);
    };
    HxCalendarRoot.prototype.getCalendarsIncludingGroupCalendars = function (sessionId) {
        return this.activeSet.getCollection(this.calendarsIncludingGroupCalendarsId, sessionId);
    };
    HxCalendarRoot.prototype.getHolidayCatalog = function (sessionId) {
        return this.activeSet.getObject(this.holidayCatalogId, sessionId).then(function (result) { return result; });
    };
    HxCalendarRoot.prototype.getIconCatalog = function (sessionId) {
        return this.activeSet.getObject(this.iconCatalogId, sessionId).then(function (result) { return result; });
    };
    HxCalendarRoot.prototype.getLocationSuggestionsDataCollections = function (sessionId) {
        return this.activeSet.getCollection(this.locationSuggestionsDataCollectionsId, sessionId);
    };
    HxCalendarRoot.prototype.getNotificationDataCache = function (sessionId) {
        return this.activeSet.getCollection(this.notificationDataCacheId, sessionId);
    };
    HxCalendarRoot.prototype.getPhotos = function (sessionId) {
        return this.activeSet.getCollection(this.photosId, sessionId);
    };
    HxCalendarRoot.prototype.getSearchResults = function (sessionId) {
        return this.activeSet.getCollection(this.searchResultsId, sessionId);
    };
    HxCalendarRoot.prototype.getSharingPermissionInfoRequestsDataCollections = function (sessionId) {
        return this.activeSet.getCollection(this.sharingPermissionInfoRequestsDataCollectionsId, sessionId);
    };
    HxCalendarRoot.prototype.getSharingPermissionsRequestsDataCollections = function (sessionId) {
        return this.activeSet.getCollection(this.sharingPermissionsRequestsDataCollectionsId, sessionId);
    };
    HxCalendarRoot.prototype.getWeather = function (sessionId) {
        return this.activeSet.getCollection(this.weatherId, sessionId);
    };
    HxCalendarRoot.prototype.getWeatherUpdates = function (sessionId) {
        return this.activeSet.getObject(this.weatherUpdatesId, sessionId).then(function (result) { return result; });
    };
    return HxCalendarRoot;
}(HxObject_1.default));
exports.HxCalendarRoot = HxCalendarRoot;
exports.default = HxCalendarRoot;
